import React from 'react';

const FAQItem = ({ question, answer }) => {
  return (
    <div style={{ marginBottom: '2rem' }}>
      <h3 style={{ fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '0.5rem' }}>{question}</h3>
      <p style={{ margin: 0, fontSize: '1rem', lineHeight: '1.5' }}>{answer}</p>
    </div>
  );
};

export default FAQItem;
